import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowBackIcon } from '@dfds-frontend/navigator-icons/icons'
import { Button } from '@dfds-pax/shared-components/client'

interface Props {
  isMultiOffer: boolean
  onMultiOfferClicked: () => void
}

export const BackToMultiOffer: FC<Props> = ({ isMultiOffer, onMultiOfferClicked }) => {
  const { t } = useTranslation()

  if (!isMultiOffer) return null

  return (
    <div className="ml-auto flex h-full flex-none cursor-pointer items-center truncate bg-transparent text-semantic-global-primary-default [&>button]:!p-0 [&>button]:!outline-none">
      <Button data-e2e="multiOfferTab" onClick={() => onMultiOfferClicked()} variant="ghostPrimary">
        <div className="typography-body-md-medium flex items-center gap-primitive-8">
          <ArrowBackIcon size="md" />
          {t('GENERAL-BACK-TO-OFFERS')}
        </div>
      </Button>
    </div>
  )
}
